var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardPlanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.3743 76.4458C102.303 76.4458 113.594 65.1544 113.594 51.2258C113.594 37.2972 102.303 26.0059 88.3743 26.0059C74.4456 26.0059 63.1543 37.2972 63.1543 51.2258C63.1543 65.1544 74.4456 76.4458 88.3743 76.4458Z",
    fill: "#987CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3038 28.5658C67.3638 33.4258 62.0438 43.9558 63.3438 54.3558C78.1538 45.9258 90.6938 50.6258 99.7538 49.0958C111.894 47.0458 110.474 37.7758 106.284 33.4558C98.8839 25.9958 87.2738 23.6958 77.3038 28.5658Z",
    fill: "#7E60E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0232 60.8162C67.2632 66.9162 97.2631 78.2062 107.073 68.1562C111.143 63.6562 113.563 57.7263 113.603 51.4062C103.703 62.0063 88.7832 54.7162 78.0232 60.8162Z",
    fill: "#7E60E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3027 28.5554C70.8227 31.7354 66.3027 37.3153 64.3027 43.6953C75.4427 49.7353 101.503 28.8854 87.0128 26.0254C83.7328 26.2054 80.4327 27.0254 77.3027 28.5554Z",
    fill: "#987CF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.573 32.3958C111.093 27.9358 118.603 26.7058 120.893 29.8458C124.543 34.8458 113.583 49.0359 96.4328 61.5459C79.2828 74.0559 62.4129 80.1458 58.7729 75.1458C56.6029 72.1658 59.9729 65.7659 66.3829 58.5559",
    stroke: "#F875B4",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7225 28.6953C99.7225 28.6953 104.793 31.2153 106.963 34.1853L100.923 37.6354L98.3125 33.2954L99.7225 28.6953Z",
    fill: "#7E60E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6523 56.2356C64.0523 58.3656 65.5023 62.0755 66.5923 63.9355L71.1724 60.3656L66.3723 54.0156L63.6523 56.2356Z",
    fill: "#987CF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPlanet);
export default __webpack_public_path__ + "static/media/card_planet.b55d14c3d98e09cf9a475657a4a9792d.svg";
export { ForwardRef as ReactComponent };